/* Native links and GET forms remain usable without JavaScript. */
if (!customElements.get('eb-house-menu')) {
  customElements.define('eb-house-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.groups = [...this.querySelectorAll('[data-eb-menu-group]')];
      this.desktop = window.matchMedia('(min-width: 900px)');
      this.resetPanels();

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-eb-menu-open]');
        if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        this.opener = trigger;
        if (!this.dialog.open) this.dialog.showModal();
        document.documentElement.classList.add('eb-menu-is-open');
        document.querySelectorAll('[data-eb-menu-open]').forEach((item) => item.setAttribute('aria-expanded', 'true'));
        this.resetPanels();
      }, options);

      this.querySelector('[data-eb-menu-close]')?.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('eb-menu-is-open');
        document.querySelectorAll('[data-eb-menu-open]').forEach((item) => item.setAttribute('aria-expanded', 'false'));
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, options);

      this.groups.forEach((group) => {
        const row = group.querySelector('.eb-house-nav__row');
        row.addEventListener('pointerenter', (event) => {
          if (this.desktop.matches && event.pointerType !== 'touch') this.activate(group);
        }, options);
        row.addEventListener('focusin', () => {
          if (this.desktop.matches) this.activate(group);
        }, options);
        group.querySelector('[data-eb-menu-expand]').addEventListener('click', () => {
          this.activate(group.classList.contains('is-active') ? null : group);
        }, options);
        group.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' && row.contains(event.target)) {
            event.preventDefault();
            this.activate(group);
            group.querySelector('[data-eb-menu-panel] a')?.focus();
          } else if (event.key === 'ArrowLeft' && !row.contains(event.target)) {
            event.preventDefault();
            group.querySelector('[data-eb-menu-parent]')?.focus();
          }
        }, options);
      });
      this.desktop.addEventListener('change', () => this.resetPanels(), options);
    }

    activate(active) {
      this.groups.forEach((group) => {
        const isActive = group === active;
        group.classList.toggle('is-active', isActive);
        group.querySelector('[data-eb-menu-expand]').setAttribute('aria-expanded', String(isActive));
        group.querySelector('[data-eb-menu-panel]').hidden = !isActive;
      });
    }

    resetPanels() {
      this.activate(this.desktop.matches ? this.groups[0] : null);
    }

    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('eb-menu-is-open');
    }
  });
}

document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-eb-sort]')) return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', event.target.value);
  url.searchParams.delete('page');
  [...url.searchParams.keys()].filter((key) => /^page_/.test(key)).forEach((key) => url.searchParams.delete(key));
  window.location.assign(url.toString());
});

// Preserve the alternate template and theme preview across Shopify pagination.
const ebPreservePageContext = (scope = document) => {
  const current = new URL(window.location.href);
  scope.querySelectorAll('[data-eb-preserve-view]').forEach((link) => {
    const next = new URL(link.href, window.location.href);
    ['view', 'q', 'type', 'sort_by', 'options[unavailable_products]', 'preview_theme_id'].forEach((key) => {
      if (current.searchParams.has(key) && !next.searchParams.has(key)) next.searchParams.set(key, current.searchParams.get(key));
    });
    link.href = next.toString();
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => ebPreservePageContext(), { once: true });
else ebPreservePageContext();
document.addEventListener('shopify:section:load', (event) => ebPreservePageContext(event.target));
